// 分頁の純ロジック。React 非依存でユニットテスト可能。
export function getTotalPages(totalItems, pageSize) {
    if (pageSize <= 0)
        return 1;
    return Math.max(1, Math.ceil(totalItems / pageSize));
}
export function clampPage(page, totalPages) {
    if (page < 1)
        return 1;
    if (page > totalPages)
        return totalPages;
    return page;
}
export function sliceItems(items, page, pageSize) {
    if (pageSize <= 0)
        return items;
    const totalPages = getTotalPages(items.length, pageSize);
    const safePage = clampPage(page, totalPages);
    const start = (safePage - 1) * pageSize;
    return items.slice(start, start + pageSize);
}
